import clsx from 'clsx';
import { FC } from 'react';
import React from 'react';
import { Button } from '../../../base-components/Button.js';
import styles from './SearchButton.module.scss';

interface Props {
  className?: string;
}

export const SearchButton: FC<Props> = ({ className }) => (
  <Button
    variant="primary"
    className={clsx(styles.button, className)}
    type="submit"
  >
    Применить
  </Button>
);
